<!--Modal to show users membership card-->
<teleport to="body">
  <div :id="modalId" class="modal fade" tabindex="-1" :aria-labelledby="`${modalId}Label`" aria-hidden="true">
    <div class="modal-dialog modal-dialog-centered modal-dialog-scrollable mx-auto membership-card-dialog">
      <div class="modal-content rounded-5 overflow-hidden border-0 shadow-lg marketplace-modal-surface">
        <div class="modal-header d-flex justify-content-start border-0 bg-black position-relative z-index-10">
          <div v-if="Object.keys(membership_card).length !== 0">
            <h5 :id="`${modalId}Label`" class="modal-title fw-bold">Membership card</h5>
            <p class="text-muted text-xs mb-0">Present this card at member venues for access.</p>
          </div>
          <button type="button" class="btn p-0 border-0 shadow-none d-flex align-items-center justify-content-center modal-close-btn ms-auto" aria-label="Close" @click="close_membership_card">
              <i class="fas fa-times fs-6 text-white"></i>
          </button>
        </div>
        <div class="modal-body membership-card-modal-body px-4 pt-3 pb-4">
          <div v-if="membership_card_loading" class="text-center py-5">
            <div class="spinner-border text-primary mb-3" role="status"></div>
            <p class="text-muted text-xs mb-0">Loading membership card...</p>
          </div>
          <div v-else-if="Object.keys(membership_card).length === 0" class="d-flex flex-column align-items-center text-center py-5 px-3 rounded-4">
          <div class="d-flex align-items-center justify-content-center rounded-circle mb-3 bg-gray campaign-image-feed">
              <i class="bi bi-credit-card-2-front text-muted font-size-28"></i>
          </div>
          <p class="mb-2 fw-bold">No Active Membership</p>
          <p class="mb-4 px-2 text-xxs text-xxs max-width-320">
              You don't have a membership yet. Subscribe to unlock access to member locations and exclusive benefits.
          </p>
          <button class="btn btn-primary text-xxs"
              @click="go_to_subscription">
              Subscribe Now
          </button>
          </div>
          <div v-else-if="membership_card" class="membership-card-content">
            <div class="digital-membership-card">
              <div class="digital-membership-card-orb digital-membership-card-orb-top"></div>
              <div class="digital-membership-card-orb digital-membership-card-orb-bottom"></div>
              <i class="bi bi-wifi digital-membership-contactless"></i>

              <div class="digital-membership-card-member">
                <div class="digital-membership-card-label">Member</div>
                <h4 class="digital-membership-card-member-name">{{ membership_card.member?.full_name }}</h4>
              </div>

              <div class="digital-membership-card-details">
                <div class="mb-3">
                  <div class="digital-membership-card-label">Member ID</div>
                  <div class="digital-membership-card-number">{{ membership_card.card_number }}</div>
                </div>
                <div>
                  <div class="digital-membership-card-label">Valid thru</div>
                  <div class="digital-membership-card-validity">{{ membership_card_valid_thru() }}</div>
                </div>
              </div>

              <span class="digital-membership-card-tier">{{ membership_card_name() }}</span>
            </div>

            <div class="digital-membership-qr-panel mt-3">
              <img v-if="membership_card_qr" :src="membership_card_qr" class="digital-membership-qr-image" alt="Scannable membership card QR code" />
              <div v-else class="text-center text-muted py-5">
                <i class="bi bi-qr-code fs-1"></i>
                <p class="text-xs mb-0 mt-2">QR code unavailable</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</teleport>
